import React from 'react'
import CalendarFullSvg from 'images/modules/Manage/i-calendar-full.svg?raw'

export { default as CalendarFullUrl } from 'images/modules/Manage/i-calendar-full.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: CalendarFullSvg}} />
)
